<script>
import footNav from "@/components/package/footer.vue";
// import MobileAppDownload from "../package/mobileAppDownload.vue";
import topNav from "@/components/package/topNav.vue";
import {mapActions} from "vuex";
import LoadingSkeleton from "../package/loadingSkeleton.vue";
import DrawerAside from "../package/DrawerAside.vue";
import HeaderSection from "../package/HeaderSection.vue";
import FooterSection from "../package/footerSection.vue";
export default {
  name: "blogView",
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D",
      gray: false,
      postId: this.$route.query.id,
      isLoading: false,
      blogDetail: {
        blogId: 0,
        title: "",
        content: "",
        author: "",
        createdOn: "",
        publishedOn: "",
        status: "",
        categoryId: 0,
        categoryName: "",
        tags: "",
        imageUrl: "",
      }
    }
  },
  components: {FooterSection, HeaderSection, DrawerAside,
    // MobileAppDownload,
    LoadingSkeleton},
  methods: {
    ...mapActions("blog" ,["getBlog"]),
    getBlogDetail(){
      this.isLoading =true;
      this.getBlog({params:{blogId:this.postId},callback:this.callback})
    },
    callback(resp){
      console.log("blogDetail",resp.data)
          if(resp.data.code==0){

            this.blogDetail = resp.data.data
          }
          this.isLoading =false;
      },
      formatDate(dateString) {
        try {
          const date = new Date(dateString);

          if (isNaN(date.getTime())) {
            return 'Invalid Date';
          }

          const year = date.toLocaleDateString('en-US', {
            timeZone: 'Australia/Adelaide',
            year: 'numeric'
          });

          const month = date.toLocaleDateString('en-US', {
            timeZone: 'Australia/Adelaide',
            month: 'long'
          });

          const day = date.toLocaleDateString('en-US', {
            timeZone: 'Australia/Adelaide',
            day: 'numeric'
          });

          return `${day} ${month} ${year}`;
        } catch (error) {
          console.error('Date formatting error:', error);
          return 'Invalid Date Format';
        }
      },
    encodeHtml(str) {
      return str
          .replace(/&/g, '&amp;') // Replace & with &amp;
          .replace(/</g, '&lt;')  // Replace < with &lt;
          .replace(/>/g, '&gt;')  // Replace > with &gt;
          .replace(/"/g, '&quot;') // Replace " with &quot;
          .replace(/'/g, '&#39;'); // Replace ' with &#39;
    },
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
      console.log("this.unfold = false");
    }
  },
  mounted() {
    this.postId = this.$route.params.id;
    this.getBlogDetail();

  }
}
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;;margin-top: 6px;">
        <el-row>
          <el-col :span="24">
            <template v-if="isLoading">
              <article class="blog-post">
               <loading-skeleton />
              </article>
            </template>
            <template v-else>
              <article class="blog-post">
                <!-- Header Section -->
                <header class="blog-header">
                  <h1 class="blog-title" v-html="blogDetail.title"></h1>
                  <div class="blog-meta">
                    <time :datetime="blogDetail.publishedOn">{{ formatDate(blogDetail.publishedOn) }}</time>
                  </div>
                </header>

                <!-- Featured Image -->
                <div v-if="blogDetail.imageUrl" class="blog-featured-image">
                  <img :src="blogDetail.imageUrl" :alt="blogDetail.blogDetail">
                </div>

                <!-- Content Section -->
                <div class="blog-content" v-html="blogDetail.content"></div>
                <!-- Footer Section -->
                <footer class="blog-footer">
<!--                  <div class="social-sharing">-->
<!--                  </div>-->


                </footer>
              </article>
            </template>

          </el-col>
        </el-row>

<!--      <mobile-app-download/>-->
    </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped lang="scss">
.blog-post {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.5rem;
}

.blog-header {
  margin-bottom: 0.5rem;
}

.blog-title {
  font-size: 0.5rem;
  margin-bottom: 0.2rem;
  background-color: #ffffff;
  color: #003333;
}

.blog-meta {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.4rem;
}

.author-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.author-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.blog-tags {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.tag {
  background: #f0f0f0;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.9rem;
}

.blog-featured-image {
  margin-bottom: 0.5rem;
  height: 500px;
}

.blog-featured-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  vertical-align: top;
  border-radius: 0.1rem;
}

.blog-content {
  line-height: 1.5;
  font-size: 12px;

}
.blog-content /deep/ p:has(img) {
  text-align: center;
}

.blog-content /deep/ h1,
.blog-content /deep/ h2,
.blog-content /deep/ h3,
.blog-content /deep/ h4,
.blog-content /deep/ h5,
.blog-content /deep/ h6,
.blog-content /deep/ p,
.blog-content /deep/ ul{
  background-color: #ffffff !important;
}
.blog-content /deep/ img{
  max-width: 100% !important;
}
.blog-content /deep/ img{
  max-width: 100% !important;
}
.blog-content /deep/ pre{
  white-space: pre-wrap;
  overflow: auto;
  max-width: 100%;
  box-sizing: border-box;
}

.blog-footer {
  margin-top: 0.2rem;
  padding-top: 0.2rem;
  border-top: 1px solid #eee;
}

.social-sharing {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

.social-sharing button {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 0.25rem;
  background: #fff;
  cursor: pointer;
}

.author-bio {
  display: flex;
  gap: 1rem;
  padding: 1.5rem;
  background: #f9f9f9;
  border-radius: 0.5rem;
  margin-bottom: 2rem;
}

.related-posts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-top: 1rem;
}

.related-post {
  padding: 1rem;
  border: 1px solid #eee;
  border-radius: 0.5rem;
}

h1,h2,h3,h4,h5,h6{
  background-color: #ffffff;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .blog-featured-image {
    height: 150px;
  }

}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .blog-featured-image {
    height: 300px;
  }

}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .blog-featured-image {
    height: 400px;
  }

}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .blog-featured-image {
    height: 500px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/blog/blogView.vue